import { Component, OnInit } from '@angular/core';
import { EnvironmentService, ENVIRONMENT } from 'src/app/environment.service';
import { ActivatedRoute } from '@angular/router';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';
@Component({
    selector: 'app-footer',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.scss'],
    standalone: false
})
export class AppFooterComponent implements OnInit {

  constructor(private appRouterDataService: AppRouterDataService) { }

  public urls: any = {};

  ngOnInit() {
    this.urls.routePlanner = AARouterURL.ROUTE_PLANNER;
    this.urls.trafficNews = AARouterURL.TRAFFIC_NEWS;
    this.urls.maps = AARouterURL.MAP_HOTELS;
  }

  public goToRoutePlanner(route): void {
    this.appRouterDataService.updateURL(route);
  }
}
